import React, { memo } from 'react'
import { CountrySelector, usePhoneInput } from 'react-international-phone';
import styles from './CommonPhoneInput.module.scss'
import { UseFormRegisterReturn } from 'react-hook-form';

type Props = {
    value: string
    noBorder?: boolean
    disabled?: boolean
    defaultCountry?: string
    registerInputProps?: UseFormRegisterReturn<any>;
    onChange: (value: string) => void
}

const CommonPhoneInput: React.FC<Props> = memo((props: Props) => {
    const { value, defaultCountry , onChange, registerInputProps, noBorder, disabled } = props
    
    
    const phoneInput = usePhoneInput({
        defaultCountry: defaultCountry,
        value: value,
        defaultMask: '... ... ....',
        forceDialCode: true,
        onChange: (data) => {
            onChange(data.phone);
        },
    });

    return (
        <div className={`${styles.phoneInputContainer} ${noBorder ? '' : styles.phoneInputBorder}`}>
            <CountrySelector
                selectedCountry={phoneInput.country.iso2}
                onSelect={(country) => phoneInput.setCountry(country.iso2)}
                dropdownArrowStyle={{ marginLeft: "0.5rem" }}
                renderButtonWrapper={renderCountries}
                disabled={true}
            />
            <input
                placeholder='Enter phone number'
                value={phoneInput.inputValue}
                type='tel'
                disabled={disabled}
                {...registerInputProps}
                onChange={phoneInput.handlePhoneValueChange}
                ref={phoneInput.inputRef}
            />
        </div>
    );

    function renderCountries(props: { children: React.ReactNode, rootProps: any }) {
        const { children, rootProps } = props;
        return (
            <button {...rootProps} className={styles.countrySelectorButtonWrapper}>
                {children}
            </button>
        );
    }
})

export default CommonPhoneInput